import { render, staticRenderFns } from "./TaskFolderDialog.vue?vue&type=template&id=29a36865&scoped=true&"
import script from "./TaskFolderDialog.vue?vue&type=script&lang=js&"
export * from "./TaskFolderDialog.vue?vue&type=script&lang=js&"
import style0 from "./TaskFolderDialog.vue?vue&type=style&index=0&id=29a36865&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a36865",
  null
  
)

export default component.exports